// extracted by mini-css-extract-plugin
export default {"scrollToTop":"MobileApp_scrollToTop__FYAhk"};